<template>
    <div class="search-field w-100 justify-content-center">
        <b-input-group>
            <b-input-group-prepend v-if="iconSide === ICON_SIDE.LEFT">
              <span class="input-group-text-coherent">
                <i :class="placeholderIcon" />
              </span>
            </b-input-group-prepend>
            <b-form-input
                    :placeholder="placeholder"
                    v-model="internalModel"
                    :class="{
                        'border-right-0': iconSide === ICON_SIDE.RIGHT,
                        'pl-0': iconSide === ICON_SIDE.LEFT,
                    }"
                    class="border-left-0"
                    :type="hasButton ? 'text' : 'search'"
                    @keyup="debouncedSearch"
                    @input="searchFieldInput"
                    @update="searchFieldUpdate"
                    @change="searchFieldChange"
                    @blur="searchFieldBlur"
            />
            <b-input-group-append v-if="iconSide === ICON_SIDE.RIGHT">
              <span class="input-group-text-coherent">
                <i :class="placeholderIcon" />
              </span>
            </b-input-group-append>
        </b-input-group>
        <b-button
                v-if="hasButton"
                variant="primary"
                size="lg"
                class="w-100"
                @click="buttonClick"
        >
            Search
        </b-button>
    </div>
</template>

<script>
    import './SearchField.scss';
    import debounce from 'lodash/debounce';

    export const ICON_SIDE = {
        LEFT: 'left',
        RIGHT: 'right'
    };

    export default {
        name: 'SearchField',
        layout: 'default',
        props: {
            value: {
                type: String,
                default: '',
            },
            placeholderIcon: {
                type: String,
                required: false,
                default: 'fal fa-search',
            },
            placeholder: {
                type: String,
                required: false,
                default: 'Search...',
            },
            iconSide: {
                type: String,
                default: ICON_SIDE.LEFT,
                validator: (value) => {
                    return Object.values(ICON_SIDE).indexOf(value) !== -1;
                }
            },
            hasButton: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                ICON_SIDE,
                internalModel: this.value,
            };
        },
        methods: {
            searchFieldInput(value) {
                if (this.hasButton) {
                    return;
                }
                this.$emit('input', this.internalModel);
            },
            searchFieldUpdate(value) {
                if (this.hasButton) {
                    return;
                }
                this.$emit('search-field:update', this.internalModel);
            },
            searchFieldChange(value) {
                if (this.hasButton) {
                    return;
                }
                this.$emit('search-field:change', this.internalModel);
            },
            searchFieldBlur(event) {
                if (this.hasButton) {
                    return;
                }
                this.$emit('search-field:blur', this.internalModel);
            },
            debouncedSearch: debounce(function () {
                if (this.hasButton) {
                    return;
                }
                this.$emit('search-field:debounced-search', this.internalModel);
            }, 1000),
            buttonClick() {
                this.$emit('input', this.internalModel);
            }
        },
    };
</script>
